import { Parametro } from "app/types/Parametro";
import { BaseApi } from "./BaseApi";

export class ParametroApi extends BaseApi {

    async obter(nome:string) : Promise<string> {
        const resposta = await this.api.post(`/Comum/ObterParametro`,{
            nome: nome
        })

        return (resposta.data as string)?.toUpperCase?.()
    }

    async obterPeloItem(nome:string, oidOtem: number) : Promise<string> { // 433263
        const resposta = await this.api.post(`/Comum/ObterParametro`,{
            nome: nome,
            oidItem: oidOtem
        })

        return (resposta.data as string)?.toUpperCase?.()
    }

    async obterVariosPorOidItem(nomes:string[], oidItem: number) : Promise<Parametro[]> {
        const resposta = await this.api.post(`/Comum/ObterParametros`,{
            parametros: nomes,
            oidItem: oidItem
        })

        const parametros: Parametro[] =  resposta.data

        return parametros.map(p => ({
            ...p,
            Valor: p.Valor?.toUpperCase?.()
        } as Parametro))
    } 


    async verificarSeExisteAlgumParametroConfigurado(nome:string, valor: string) : Promise<boolean> {
        const resposta = await this.api.post(`/Comum/VerificarSeExisteAlgumParametroConfigurado`,{
            parametro: nome,
            valor
        })

        return resposta.data
    }
    
    async obterVarios(nomes:string[]) : Promise<Parametro[]> {
        const resposta = await this.api.post(`/Comum/ObterParametros`,{
            parametros: nomes
        })

        const parametros: Parametro[] =  resposta.data

        return parametros.map(p => ({
            ...p,
            Valor: p.Valor?.toUpperCase?.()
        } as Parametro))
    }  
}